'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './memType.routes.js';
import MemTypeListCtrl from './list/list.controller.js';
import MemTypeViewCtrl from './view/view.controller.js';
import MemTypeFormCtrl from './form/form.controller.js';

export default angular.module('georgeApp.memType',
  [uiRouter])
  .config(routing)
  .controller('MemTypeListCtrl', MemTypeListCtrl)
  .controller('MemTypeViewCtrl', MemTypeViewCtrl)
  .controller('MemTypeFormCtrl', MemTypeFormCtrl)
  .name;
